;(function () {
  'use strict'

  angular
    .module('contrast.trace.events')
    .controller('csTraceEventsCtrl', csTraceEventsCtrl)

  function csTraceEventsCtrl() {
    'ngInject'

    var vm

    this.$onInit = function () {
      vm = this
      init()
    }

    function init() {
      addViewDataToEvents()
    }

    function addViewDataToEvents() {
      vm.events.forEach(function (event) {
        event.traceUuid = vm.traceUuid
        event.traceLanguage = vm.traceLanguage
        if (
          event.collapsedEvents &&
          angular.isArray(event.collapsedEvents) &&
          event.collapsedEvents.length > 0
        ) {
          addParentIdToChildEvents(event)
        }
      })
    }

    function addParentIdToChildEvents(event) {
      var i,
        len = event.collapsedEvents.length,
        child
      for (i = 0; i < len; i++) {
        child = event.collapsedEvents[i]
        child.parentId = event.id
      }
    }
  }
})()
